import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UserState {
  student_uuid: number;
  student_id?: string;
  student_name: string;
  student_gender?: number;
  student_grade?: number;
  college_ci?: string;
  college_name?: string;
  college_country_id?: number;
  college_country_name?: string;
  student_birth?: string;
  student_no?: string;
  student_college?: string;
  /** 로그인 토큰(JWT). 요청마다 Authorization 으로 붙인다 (ENR-BUGFIX-127) */
  token?: string;
  /** 토큰을 받은 이 PC 의 시각(ms). 만료 판단에 쓴다 */
  token_received_at?: number;
}

const initialState: UserState = {
  student_uuid: 0,
  student_name: '',
};

// name, initialState, reducers.
export const userSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    signIn(_, action: PayloadAction<UserState>) {
      return action.payload;
    },
    signOut() {
      return initialState;
    },
  },
});

export const { signIn, signOut } = userSlice.actions;
export default userSlice.reducer;
